import type { IconType } from "@circle-react-shared/Icon";
import type { RegisteredRouter } from "@tanstack/react-router";
import type { RouteToPath } from "@tanstack/router-core";

import { t } from "@/i18n-js/instance";

export const INVITE_TAB = {
  DETAILS: "details",
  PERMISSIONS: "permissions",
  ACCESS: "access",
  NEWSLETTERS: "newsletters",
  EMAILS: "emails",
  PAYWALLS: "paywalls",
} as const;

export type InviteTab = (typeof INVITE_TAB)[keyof typeof INVITE_TAB];

export const INVITE_TABS: readonly InviteTab[] = Object.values(INVITE_TAB);

type InviteTabPath<TTab extends InviteTab = InviteTab> = Extract<
  RouteToPath<RegisteredRouter>,
  `/settings/members/invite/${TTab}`
>;

type InviteTabPaths = {
  [Tab in InviteTab]: InviteTabPath<Tab>;
};

export const INVITE_TAB_PATHS = {
  [INVITE_TAB.DETAILS]: "/settings/members/invite/details",
  [INVITE_TAB.PERMISSIONS]: "/settings/members/invite/permissions",
  [INVITE_TAB.ACCESS]: "/settings/members/invite/access",
  [INVITE_TAB.NEWSLETTERS]: "/settings/members/invite/newsletters",
  [INVITE_TAB.EMAILS]: "/settings/members/invite/emails",
  [INVITE_TAB.PAYWALLS]: "/settings/members/invite/paywalls",
} as const satisfies InviteTabPaths;

export const isInviteTab = (tab: string): tab is InviteTab =>
  INVITE_TABS.includes(tab as InviteTab);

export const INVITE_TYPE = "invite_type";
export const INVITE_TYPE_EMAIL = "email";
export const INVITE_TYPE_CSV = "csv";
export const SKIP_INVITATION = "skip_invitation";

interface Option {
  icon: {
    type: IconType;
    viewBox: string;
    className: string;
  };
  label: string;
  value: string;
}

export const INVITE_OPTIONS: Option[] = [
  {
    get label() {
      return t("settings.invite_members.details_tab.invite_types.by_email");
    },
    icon: {
      type: "20-manual-invite",
      viewBox: "0 0 20 20",
      className: "!h-5 !w-5",
    },
    value: INVITE_TYPE_EMAIL,
  },
  {
    get label() {
      return t("settings.invite_members.details_tab.invite_types.import_csv");
    },
    icon: {
      type: "20-folder-open",
      viewBox: "0 0 20 20",
      className: "!h-5 !w-5",
    },
    value: INVITE_TYPE_CSV,
  },
];
